import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CompanyGeneralData } from '@pxtra-client-lib-legacy/gen';
import { DataGrid, DataGridElement } from '../../../../lib/components/compound/dataGrid';
import { countryLabel } from '../../../../misc/countries';

interface Props {
  data?: CompanyGeneralData;
}

export const GeneralDataView: FC<Props> = ({ data }) => {
  const { t, i18n } = useTranslation();
  const language = i18n.resolvedLanguage;

  return (
    <DataGrid>
      <DataGridElement title={t('company:STREET')} value={data?.address?.street_name} />
      <DataGridElement title={t('company:STREET_NUMBER')} value={data?.address?.street_number} />
      <DataGridElement
        title={t('company:ADDITION_TO_ADDRESS')}
        value={data?.address?.address_supplement}
        xs={12}
      />
      <DataGridElement title={t('company:ZIP_CODE')} value={data?.address?.zip_code} />
      <DataGridElement title={t('company:CITY')} value={data?.address?.city} />
      <DataGridElement title={t('company:PROVINCE')} value={data?.address?.province} />
      <DataGridElement
        title={t('company:COUNTRY')}
        value={countryLabel(data?.address?.country, language)}
      />
    </DataGrid>
  );
};
